import { PureComponent } from 'react'
import { connect } from 'react-redux'

import './styles/unauthorized.css'

class CustomErrorPage extends PureComponent {
  render() {
    const { permissions, title, message } = this.props

    if (!permissions || Object.keys(permissions).length === 0) return null

    return (
      <div className="unauthorized-main-div">
        <div>
          <span>{title || 'ERROR 404'}</span>
          <span>{message || 'Page not found.'}</span>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  permissions: state.permissions.userPermissions
})

export default connect(mapStateToProps)(CustomErrorPage)
